import { ProductSingleProps } from "../../../queries/archive";
import _ from "lodash";

export const hasProductDetails = (product: ProductSingleProps) => {
  return _.some(product.productOptions, (item) => item !== null);
};
